import equal$1 from 'fast-deep-equal';
import { distinctUntilChanged, filter, map, withLatestFrom, first, tap, mergeMapTo } from 'rxjs/operators';
import { pipe, isObservable, of, combineLatest, forkJoin } from 'rxjs';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, NgZone, Inject, PLATFORM_ID, Optional, inject, isDevMode, Directive, ElementRef, Renderer2, Input, HostListener, NgModule } from '@angular/core';
import * as i2 from 'ng-recaptcha';
import { ReCaptchaV3Service, RECAPTCHA_V3_SITE_KEY, RECAPTCHA_BASE_URL, RECAPTCHA_NONCE, RECAPTCHA_LANGUAGE } from 'ng-recaptcha';
import { isScullyRunning } from '@scullyio/ng-lib';
import * as i1 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import cloneDeep from 'clone-deep';
import { v4 } from 'uuid';
import { HttpParams } from '@angular/common/http';
import { select } from '@ngrx/store';
import { EditorContextHelper } from '@magnolia/template-annotations';
import { localStorageSync } from 'ngrx-store-localstorage';
import * as i3 from '@angular/router';
import { ActivatedRoute, NavigationStart, NavigationEnd, Router } from '@angular/router';
import { __decorate, __metadata } from 'tslib';
import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import * as i2$1 from '@angular/platform-browser';
import { Title, Meta } from '@angular/platform-browser';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/platform-browser';
function distinctUntilChangedDeep() {
    return distinctUntilChanged((previous, current) => {
        return equal$1(previous, current);
    });
}

function distinctUntilKeysChanged(...keys) {
    return distinctUntilChanged((previous, current) => {
        return keys.every((key) => equal$1(previous && previous[key], current && current[key]));
    });
}

function isDefined(value) {
    return value !== undefined && value !== null;
}
function filterNullUndefined() {
    return function (source) {
        return source.pipe(filter(isDefined), map((value) => value));
    };
}

function mapToLatestFrom(source$) {
    return pipe(withLatestFrom(source$), map((values) => values.pop()));
}

const WINDOW = new InjectionToken('WindowToken', {
    providedIn: 'root',
    factory: () => {
        /* istanbul ignore if  */
        if (typeof window === 'undefined' || !window.document) {
            // this is ignored from coverage because it is:
            // a. basically impossible to test
            // b. an edge case that we dont think will happen
            //    and are not sure why we even have this condition
            //    but dont want to regress any code
            return undefined;
        }
        return window;
    },
});

// this next line fixes "Could not resolve type Window" build error we get when
// exporting a class that uses the Window type
/** @dynamic */
class RecaptchaWithCleanupService extends ReCaptchaV3Service {
    constructor(zone, siteKey, platformId, win, doc, baseUrl, nonce, language) {
        super(zone, siteKey, platformId, baseUrl, nonce, language);
        this.doc = doc;
        if (!isScullyRunning()) {
            return;
        }
        if (win.grecaptcha) {
            this.cleanup();
            return;
        }
        const scriptEl = doc.querySelector('script[src*="recaptcha"]');
        if (scriptEl) {
            scriptEl.addEventListener('load', () => this.cleanup());
        }
        else {
            console.error('ReCaptcha script el not found!');
        }
    }
    cleanup() {
        Array.from(this.doc.querySelectorAll('script[src*="recaptcha"],.grecaptcha-badge')).forEach((e) => e.remove());
    }
}
RecaptchaWithCleanupService.ɵfac = function RecaptchaWithCleanupService_Factory(t) { return new (t || RecaptchaWithCleanupService)(ɵngcc0.ɵɵinject(ɵngcc0.NgZone), ɵngcc0.ɵɵinject(RECAPTCHA_V3_SITE_KEY), ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(WINDOW), ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(RECAPTCHA_BASE_URL, 8), ɵngcc0.ɵɵinject(RECAPTCHA_NONCE, 8), ɵngcc0.ɵɵinject(RECAPTCHA_LANGUAGE, 8)); };
RecaptchaWithCleanupService.ɵprov = i0.ɵɵdefineInjectable({ factory: function RecaptchaWithCleanupService_Factory() { return new RecaptchaWithCleanupService(i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(i2.RECAPTCHA_V3_SITE_KEY), i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(WINDOW), i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(i2.RECAPTCHA_BASE_URL, 8), i0.ɵɵinject(i2.RECAPTCHA_NONCE, 8), i0.ɵɵinject(i2.RECAPTCHA_LANGUAGE, 8)); }, token: RecaptchaWithCleanupService, providedIn: "root" });
RecaptchaWithCleanupService.ctorParameters = () => [
    { type: NgZone },
    { type: String, decorators: [{ type: Inject, args: [RECAPTCHA_V3_SITE_KEY,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [RECAPTCHA_BASE_URL,] }] },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [RECAPTCHA_NONCE,] }] },
    { type: String, decorators: [{ type: Optional }, { type: Inject, args: [RECAPTCHA_LANGUAGE,] }] }
];

function combineLatestObj(obj) {
    const entries = Object.entries(obj);
    const sources$ = entries.map(([key, value]) => {
        const value$ = isObservable(value) ? value : of(value);
        return value$.pipe(map((value) => ({ key, value })));
    });
    return combineLatest(sources$).pipe(map((sources) => sources.reduce((result, partial) => (Object.assign(Object.assign({}, result), { [partial.key]: partial.value })), {})));
}

function retrieveErrorMessage(error) {
    if ('error' in error) {
        return error.error.message;
    }
    return error.message;
}
function retrieveErrorStatusCode(error) {
    if ('error' in error) {
        return error.error.status;
    }
    return;
}

function forkJoinObj(obj) {
    const entries = Object.entries(obj);
    const sources$ = entries.map(([key, value]) => {
        const value$ = isObservable(value) ? value.pipe(first()) : of(value);
        return value$.pipe(map((value) => ({ key, value })));
    });
    return forkJoin(sources$).pipe(map((sources) => sources.reduce((result, partial) => (Object.assign(Object.assign({}, result), { [partial.key]: partial.value })), {})));
}

function clone(obj) {
    const dolly = cloneDeep(obj);
    return dolly;
}
function equal(a, b) {
    return equal$1(a, b);
}
function generateId() {
    return v4();
}

function formatUrl(url) {
    const protocolRegexp = new RegExp(/(http|https):\/{2}/);
    const protocolMatch = url.match(protocolRegexp);
    const protocol = (protocolMatch && protocolMatch[0]) || '';
    const path = url
        .replace(protocolRegexp, '')
        .replace(/\/{2,}/g, '/')
        .replace(/\/+$/, '');
    return `${protocol}${path}`;
}
function buildUrl(url, params = {}) {
    const queryString = httpParamsFromObject(params).toString();
    if (queryString) {
        return `${url}?${queryString}`;
    }
    return url;
}
function httpParamsFromObject(obj) {
    const formattedParams = Object.entries(obj).reduce((params, [key, param]) => {
        const formattedParam = Array.isArray(param)
            ? formatHttpArrayParam(param)
            : formatHttpParam(param);
        if (formattedParam) {
            return Object.assign(Object.assign({}, params), { [key]: formattedParam });
        }
        return params;
    }, {});
    return new HttpParams({ fromObject: formattedParams });
}
function formatHttpParam(param) {
    switch (typeof param) {
        case 'string':
            return param;
        case 'number':
            return param.toString();
        case 'boolean':
            return param.toString();
        default:
            return undefined;
    }
}
function formatHttpArrayParam(param) {
    return param.reduce((formattedParam, childParam) => {
        const formattedChildParam = formatHttpParam(childParam);
        if (formattedChildParam) {
            return [formattedChildParam, ...formattedParam];
        }
        return formattedParam;
    }, []);
}
function formatHttpPayload(payload) {
    if (!(payload instanceof Object) || payload instanceof Array) {
        return payload;
    }
    return Object.entries(payload).reduce((formattedPayload, [key, property]) => {
        return Object.assign(Object.assign({}, formattedPayload), { [key]: formatHttpPayloadProperty(property) });
    }, {});
}
function formatHttpPayloadProperty(property) {
    if (Array.isArray(property)) {
        return property
            .map((property) => formatHttpPayloadProperty(property))
            .filter((property) => property !== null && property !== undefined);
    }
    else if (typeof property === 'string') {
        return property === '' ? undefined : property;
    }
    else if (property === null || property === undefined) {
        return property;
    }
    else if (typeof property === 'object') {
        return formatHttpPayload(property);
    }
    return property;
}

function getRouteUrl(snapshot) {
    return snapshot.pathFromRoot
        .map((route) => route.url.toString())
        .join('/')
        .replace(/\/+/g, '/');
}
function getActivatedRoute(routerState) {
    let route = routerState.root;
    while (route.firstChild) {
        route = route.firstChild;
    }
    return route;
}
function getRouteData(snapshot) {
    if (!snapshot) {
        return {};
    }
    let data = Object.assign({}, snapshot.root.data);
    let route = snapshot.root;
    while (route) {
        data = Object.assign(Object.assign({}, data), route.data);
        route = route.firstChild;
    }
    return data;
}
function getRouteParams(snapshot) {
    if (!snapshot) {
        return {};
    }
    let params = Object.assign({}, snapshot.root.params);
    let route = snapshot.root;
    while (route) {
        params = Object.assign(Object.assign({}, params), route.params);
        route = route.firstChild;
    }
    return params;
}

function selectDispatchIfUndefined(store, selector, action) {
    const selector$ = store.pipe(select(selector));
    return selector$.pipe(first(), tap((result) => {
        if (result === null || result === undefined) {
            store.dispatch(action);
        }
    }), mergeMapTo(selector$));
}

function sessionStorageEnabled() {
    try {
        sessionStorage.setItem('session-storage-enabled', 'enabled');
        sessionStorage.removeItem('session-storage-enabled');
        return true;
    }
    catch (error) {
        return false;
    }
}
function memoryStorageSync(reducer) {
    return (state, action) => reducer(state, action);
}
function sessionStorageSync(config) {
    return function (reducer) {
        const isInMagnolia = EditorContextHelper.isSameOrigin() === false;
        const enabled = sessionStorageEnabled();
        if (enabled) {
            return localStorageSync({
                keys: config.keys,
                storage: sessionStorage,
                rehydrate: isInMagnolia ? false : config.rehydrate,
            })(reducer);
        }
        return memoryStorageSync(reducer);
    };
}

const GOOGLE_TAG_MANAGER = new InjectionToken('GoogleTagManager', {
    providedIn: 'root',
    factory: () => {
        var _a;
        return (((_a = inject(WINDOW)) === null || _a === void 0 ? void 0 : _a.dataLayer) || {
            push: () => console.warn('window.dataLayer is not defined.'),
        });
    },
});

class DevModeService {
    isDevMode() {
        return isDevMode();
    }
}
DevModeService.ɵfac = function DevModeService_Factory(t) { return new (t || DevModeService)(); };
DevModeService.ɵprov = i0.ɵɵdefineInjectable({ factory: function DevModeService_Factory() { return new DevModeService(); }, token: DevModeService, providedIn: "root" });

var GtmPropStyle;
(function (GtmPropStyle) {
    GtmPropStyle["camelCase"] = "camelCase";
    GtmPropStyle["snakeCase"] = "snakeCase";
})(GtmPropStyle || (GtmPropStyle = {}));

const gtmConfigDefaults = {
    defaultPageViewEvent: 'spa-pageview',
    globalPageViewProps: {},
    globalProps: {},
    propStyle: GtmPropStyle.snakeCase,
    eventGeneric: 'gaEvent',
};
const applyDefaults = (config) => {
    return Object.assign(Object.assign({}, gtmConfigDefaults), (config || {}));
};

const GTM_CONFIG = new InjectionToken('GtmConfig');

class GtmConfigService {
    constructor(providedConfig) {
        this.providedConfig = providedConfig;
        this.config = Object.freeze(applyDefaults(this.providedConfig));
        this.propKeys = Object.freeze({
            action: this.config.propStyle === GtmPropStyle.snakeCase ? 'event_action' : 'eventAction',
            category: this.config.propStyle === GtmPropStyle.snakeCase ? 'event_category' : 'eventCategory',
            label: this.config.propStyle === GtmPropStyle.snakeCase ? 'event_label' : 'eventLabel',
        });
    }
}
GtmConfigService.ɵfac = function GtmConfigService_Factory(t) { return new (t || GtmConfigService)(ɵngcc0.ɵɵinject(GTM_CONFIG, 8)); };
GtmConfigService.ɵprov = i0.ɵɵdefineInjectable({ factory: function GtmConfigService_Factory() { return new GtmConfigService(i0.ɵɵinject(GTM_CONFIG, 8)); }, token: GtmConfigService, providedIn: "root" });
GtmConfigService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [GTM_CONFIG,] }] }
];

class GtmService {
    constructor(gtm, devModeService, route, configService) {
        this.gtm = gtm;
        this.devModeService = devModeService;
        this.route = route;
        this.configService = configService;
        this.globalProperties = {};
        this.globalPageViewProperties = {};
        this.config = this.configService.config;
    }
    patchGlobalProperties(data) {
        this.globalProperties = Object.assign(Object.assign({}, this.globalProperties), data);
    }
    clearGlobalProperties() {
        this.globalProperties = {};
    }
    patchGlobalPageViewProperties(data) {
        this.globalPageViewProperties = Object.assign(Object.assign({}, this.globalPageViewProperties), data);
    }
    clearGlobalPageViewProperties() {
        this.globalPageViewProperties = {};
    }
    push(payload) {
        const combined = Object.assign(Object.assign(Object.assign(Object.assign({}, this.config.globalProps), this.globalProperties), this.routeData), payload);
        if (this.devModeService.isDevMode()) {
            console.log('%c🕵️ Analytics Service', 'font-weight:bold; font-size:18px; margin-bottom:8px;', combined);
        }
        this.gtm.push(combined);
    }
    pageView(payload, event) {
        this.push(Object.assign(Object.assign(Object.assign(Object.assign({}, this.config.globalPageViewProps), this.globalPageViewProperties), payload), { event: event || this.config.defaultPageViewEvent }));
    }
    get routeData() {
        const routeData = getRouteData(this.route.snapshot);
        return routeData.gtmData;
    }
}
GtmService.ɵfac = function GtmService_Factory(t) { return new (t || GtmService)(ɵngcc0.ɵɵinject(GOOGLE_TAG_MANAGER), ɵngcc0.ɵɵinject(DevModeService), ɵngcc0.ɵɵinject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵinject(GtmConfigService)); };
GtmService.ɵprov = i0.ɵɵdefineInjectable({ factory: function GtmService_Factory() { return new GtmService(i0.ɵɵinject(GOOGLE_TAG_MANAGER), i0.ɵɵinject(DevModeService), i0.ɵɵinject(i3.ActivatedRoute), i0.ɵɵinject(GtmConfigService)); }, token: GtmService, providedIn: "root" });
GtmService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [GOOGLE_TAG_MANAGER,] }] },
    { type: DevModeService },
    { type: ActivatedRoute },
    { type: GtmConfigService }
];

// this next line fixes "Could not resolve type Window" build error we get when
// exporting a class that uses the Window type
/** @dynamic */
class GtmButtonDirective {
    constructor(el, renderer, ga, window, configService) {
        this.el = el;
        this.renderer = renderer;
        this.ga = ga;
        this.window = window;
        this.configService = configService;
    }
    ngAfterViewInit() {
        const anchor = this.el.nativeElement.querySelector('a,button');
        this.renderer.listen(anchor, 'click', (event) => {
            const target = event.currentTarget;
            const routerLink = this.routerLink;
            const href = target.getAttribute('href');
            //todo: do we really need this?
            if (href && !routerLink && !this.isNewWindow(event)) {
                event.preventDefault();
                setTimeout(() => {
                    this.window.location.href = href;
                }, 100);
            }
            const innerText = anchor.textContent;
            this.ga.push(this.gtmPayload || Object.assign(Object.assign({ event: this.configService.config.eventGeneric, [this.configService.propKeys.action]: this.gtmAction || 'CTA Click' }, (this.gtmCategory ? { [this.configService.propKeys.category]: this.gtmCategory } : {})), { [this.configService.propKeys.label]: innerText }));
        });
    }
    isNewWindow(event) {
        const target = event.currentTarget.getAttribute('target');
        return ((target && target !== '_self') ||
            event.ctrlKey ||
            event.shiftKey ||
            event.metaKey || // apple
            (typeof event.button !== 'undefined' && event.button == 1) //middle click
        );
    }
}
GtmButtonDirective.ɵfac = function GtmButtonDirective_Factory(t) { return new (t || GtmButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(GtmService), ɵngcc0.ɵɵdirectiveInject(WINDOW), ɵngcc0.ɵɵdirectiveInject(GtmConfigService)); };
GtmButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: GtmButtonDirective, selectors: [["", "dgxFdnGtmButton", ""]], inputs: { gtmPayload: "gtmPayload", gtmAction: "gtmAction", gtmCategory: "gtmCategory", routerLink: "routerLink" } });
GtmButtonDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: GtmService },
    { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: GtmConfigService }
];
GtmButtonDirective.propDecorators = {
    gtmPayload: [{ type: Input }],
    gtmAction: [{ type: Input }],
    gtmCategory: [{ type: Input }],
    routerLink: [{ type: Input }]
};

// this next line fixes "Could not resolve type Window" build error we get when
// exporting a class that uses the Window type
/** @dynamic */
class GtmLinkDirective {
    constructor(el, ga, window, configService) {
        this.el = el;
        this.ga = ga;
        this.window = window;
        this.configService = configService;
    }
    onClick(event) {
        if (this.gtmPayload === false) {
            return;
        }
        const routerLink = Array.isArray(this.routerLink) ? this.routerLink.join('/') : this.routerLink;
        const href = this.el.nativeElement.getAttribute('href');
        const innerText = this.el.nativeElement.textContent;
        if (!routerLink && !this.isNewWindow(event)) {
            event.preventDefault();
            setTimeout(() => {
                this.window.location.href = href;
            }, 100);
        }
        this.ga.push(this.gtmPayload || {
            event: this.configService.config.eventGeneric,
            [this.configService.propKeys.action]: 'Link Click',
            [this.configService.propKeys.label]: innerText,
            href: routerLink || href,
        });
    }
    isNewWindow(event) {
        const target = this.el.nativeElement.getAttribute('target');
        return ((target && target !== '_self') ||
            event.ctrlKey ||
            event.shiftKey ||
            event.metaKey || // apple
            (typeof event.button !== 'undefined' && event.button == 1) //middle click
        );
    }
}
GtmLinkDirective.ɵfac = function GtmLinkDirective_Factory(t) { return new (t || GtmLinkDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(GtmService), ɵngcc0.ɵɵdirectiveInject(WINDOW), ɵngcc0.ɵɵdirectiveInject(GtmConfigService)); };
GtmLinkDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: GtmLinkDirective, selectors: [["", "dgxFdnGtmLink", ""]], hostBindings: function GtmLinkDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function GtmLinkDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } }, inputs: { gtmPayload: "gtmPayload", routerLink: "routerLink" } });
GtmLinkDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: GtmService },
    { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: GtmConfigService }
];
GtmLinkDirective.propDecorators = {
    gtmPayload: [{ type: Input }],
    routerLink: [{ type: Input }],
    onClick: [{ type: HostListener, args: ['click', ['$event'],] }]
};

const directives = [GtmButtonDirective, GtmLinkDirective];
class SharedUtilGtmModule {
}
SharedUtilGtmModule.ɵfac = function SharedUtilGtmModule_Factory(t) { return new (t || SharedUtilGtmModule)(); };
SharedUtilGtmModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SharedUtilGtmModule });
SharedUtilGtmModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });

class QMSanitiseDirective {
    constructor(renderer, hostElement) {
        this.renderer = renderer;
        this.hostElement = hostElement;
    }
    ngOnInit() {
        switch (this.dgxFdnQmSanitise) {
            case 'block':
                this.setAttribute('data-qm-block');
                return;
            case 'encrypt':
                this.setAttribute('data-qm-encrypt');
                return;
            default:
                return;
        }
    }
    setAttribute(name) {
        this.renderer.setAttribute(this.hostElement.nativeElement, name, 'true');
    }
}
QMSanitiseDirective.ɵfac = function QMSanitiseDirective_Factory(t) { return new (t || QMSanitiseDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
QMSanitiseDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: QMSanitiseDirective, selectors: [["", "dgxFdnQmSanitise", ""]], inputs: { dgxFdnQmSanitise: "dgxFdnQmSanitise" } });
QMSanitiseDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
QMSanitiseDirective.propDecorators = {
    dgxFdnQmSanitise: [{ type: Input }]
};

var QuantumMetricsTransition;
(function (QuantumMetricsTransition) {
    QuantumMetricsTransition["Start"] = "QuantumMetricsTransitionStart";
    QuantumMetricsTransition["Stop"] = "QuantumMetricsTransitionStop";
})(QuantumMetricsTransition || (QuantumMetricsTransition = {}));

/** @dynamic */
let QuantumMetricsService = class QuantumMetricsService {
    constructor(window, router) {
        this.window = window;
        this.router = router;
    }
    trackNavigation() {
        this.trackNavigationStart();
        this.trackNavigationEnd();
    }
    trackNavigationStart() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationStart), untilDestroyed(this))
            .subscribe(() => {
            this.window.performance.mark(QuantumMetricsTransition.Start);
        });
    }
    trackNavigationEnd() {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd), untilDestroyed(this))
            .subscribe(() => {
            this.window.performance.mark(QuantumMetricsTransition.Stop);
        });
    }
};
QuantumMetricsService.ɵfac = function QuantumMetricsService_Factory(t) { return new (t || QuantumMetricsService)(ɵngcc0.ɵɵinject(WINDOW), ɵngcc0.ɵɵinject(ɵngcc1.Router)); };
QuantumMetricsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: QuantumMetricsService, factory: function (t) { return QuantumMetricsService.ɵfac(t); } });
QuantumMetricsService.ctorParameters = () => [
    { type: Window, decorators: [{ type: Inject, args: [WINDOW,] }] },
    { type: Router }
];
QuantumMetricsService = __decorate([
    UntilDestroy(),
    __metadata("design:paramtypes", [Window, Router])
], QuantumMetricsService);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RecaptchaWithCleanupService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.NgZone }, { type: String, decorators: [{
                type: Inject,
                args: [RECAPTCHA_V3_SITE_KEY]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RECAPTCHA_BASE_URL]
            }] }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RECAPTCHA_NONCE]
            }] }, { type: String, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [RECAPTCHA_LANGUAGE]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DevModeService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GtmConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [GTM_CONFIG]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GtmService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [GOOGLE_TAG_MANAGER]
            }] }, { type: DevModeService }, { type: ɵngcc1.ActivatedRoute }, { type: GtmConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GtmButtonDirective, [{
        type: Directive,
        args: [{
                selector: '[dgxFdnGtmButton]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: GtmService }, { type: Window, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: GtmConfigService }]; }, { gtmPayload: [{
            type: Input
        }], gtmAction: [{
            type: Input
        }], gtmCategory: [{
            type: Input
        }], routerLink: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GtmLinkDirective, [{
        type: Directive,
        args: [{
                selector: '[dgxFdnGtmLink]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: GtmService }, { type: Window, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: GtmConfigService }]; }, { onClick: [{
            type: HostListener,
            args: ['click', ['$event']]
        }], gtmPayload: [{
            type: Input
        }], routerLink: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharedUtilGtmModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [...directives],
                exports: [...directives]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharedUtilGtmModule, { declarations: function () { return [GtmButtonDirective, GtmLinkDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [GtmButtonDirective, GtmLinkDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QMSanitiseDirective, [{
        type: Directive,
        args: [{
                selector: '[dgxFdnQmSanitise]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { dgxFdnQmSanitise: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(QuantumMetricsService, [{
        type: Injectable
    }], function () { return [{ type: Window, decorators: [{
                type: Inject,
                args: [WINDOW]
            }] }, { type: ɵngcc1.Router }]; }, null); })();

class SharedUtilQuantumMetricsModule {
    static forRoot() {
        return {
            ngModule: SharedUtilQuantumMetricsModule,
            providers: [QuantumMetricsService],
        };
    }
}
SharedUtilQuantumMetricsModule.ɵfac = function SharedUtilQuantumMetricsModule_Factory(t) { return new (t || SharedUtilQuantumMetricsModule)(); };
SharedUtilQuantumMetricsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SharedUtilQuantumMetricsModule });
SharedUtilQuantumMetricsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharedUtilQuantumMetricsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [QMSanitiseDirective],
                exports: [QMSanitiseDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharedUtilQuantumMetricsModule, { declarations: function () { return [QMSanitiseDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [QMSanitiseDirective]; } }); })();

const SEO_CONFIG = new InjectionToken('SEO Config Token');

const BASE_URL = new InjectionToken('BaseUrl Token', {
    providedIn: 'root',
    factory: () => {
        const doc = inject(DOCUMENT);
        const seoConfig = inject(SEO_CONFIG);
        let baseUrl;
        if (seoConfig.baseUrl) {
            baseUrl = seoConfig.baseUrl;
        }
        else {
            const url = new URL(doc.URL);
            url.hash = '';
            url.search = '';
            url.pathname = '';
            baseUrl = url.href;
        }
        return baseUrl.replace(/\/*$/, '/');
    },
});

/** @dynamic */
class CanonicalService {
    constructor(dom, baseUrl) {
        this.dom = dom;
        this.baseUrl = baseUrl;
    }
    setCanonicalUrl(url) {
        let canonicalUrl = url == undefined ? this.dom.URL : url;
        const cUrl = new URL(canonicalUrl);
        //todo: baseUrl could have been automatically generated from this.dom.URL - optimise to avoid calculating again?
        if (this.baseUrl) {
            const baseUrl = new URL(this.baseUrl);
            cUrl.hostname = baseUrl.hostname;
            cUrl.protocol = baseUrl.protocol;
            cUrl.port = baseUrl.port;
            if (baseUrl.pathname && baseUrl.pathname.split('/')[1]) {
                const baseUrlPath = baseUrl.pathname.replace(/\/$/, '');
                cUrl.pathname = `${baseUrlPath}${cUrl.pathname}`;
            }
        }
        if (!url) {
            //if we use the dom url then we need to strip the query string and hash
            //todo: we dont always want the full set of query params in here
            //      but sometimes we want some - add some kind of whitelist?
            cUrl.search = '';
            cUrl.hash = '';
        }
        canonicalUrl = cUrl.href;
        //todo: should url be protocol agnostic? i.e. // instead of https://
        let link = this.dom.querySelector(`link[rel='canonical']`) || null;
        if (link === null) {
            link = this.dom.createElement('link');
            this.dom.head.appendChild(link);
            link.setAttribute('rel', 'canonical');
        }
        link.setAttribute('href', canonicalUrl);
    }
}
CanonicalService.ɵfac = function CanonicalService_Factory(t) { return new (t || CanonicalService)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(BASE_URL, 8)); };
CanonicalService.ɵprov = i0.ɵɵdefineInjectable({ factory: function CanonicalService_Factory() { return new CanonicalService(i0.ɵɵinject(i1.DOCUMENT), i0.ɵɵinject(BASE_URL, 8)); }, token: CanonicalService, providedIn: "root" });
CanonicalService.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [BASE_URL,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CanonicalService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [BASE_URL]
            }] }]; }, null); })();

/** @dynamic */
class JsonLdService {
    constructor(document) {
        this.document = document;
    }
    insertSchema(schema) {
        const script = this.document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(schema);
        this.document.head.appendChild(script);
    }
}
JsonLdService.ɵfac = function JsonLdService_Factory(t) { return new (t || JsonLdService)(ɵngcc0.ɵɵinject(DOCUMENT)); };
JsonLdService.ɵprov = i0.ɵɵdefineInjectable({ factory: function JsonLdService_Factory() { return new JsonLdService(i0.ɵɵinject(i1.DOCUMENT)); }, token: JsonLdService, providedIn: "root" });
JsonLdService.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(JsonLdService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, null); })();

const prefixKeys = (data, prefix) => {
    const keys = Object.keys(data);
    return keys.reduce((agg, key) => (Object.assign(Object.assign({}, agg), { [`${prefix}:${key}`]: data[key] })), {});
};
const ɵ0 = prefixKeys;
const flattenOgData = (opengraph) => {
    const keys = Object.keys(opengraph);
    return keys.reduce((agg, key) => {
        const value = opengraph[key];
        if (typeof value === 'object') {
            return Object.assign(Object.assign({}, agg), prefixKeys(value, key));
        }
        else {
            return Object.assign(Object.assign({}, agg), { [key]: value });
        }
    }, {});
};
const ɵ1 = flattenOgData;
const ogRecordToArray = (opengraph) => {
    const flattened = flattenOgData(opengraph);
    const keys = Object.keys(flattened);
    return keys.map((key) => ({
        property: `og:${key}`,
        content: flattened[key],
    }));
};

class SeoService {
    constructor(canonical, titleService, metaTagService, jsonLd, config) {
        this.canonical = canonical;
        this.titleService = titleService;
        this.metaTagService = metaTagService;
        this.jsonLd = jsonLd;
        this.config = config;
    }
    handleSeo(data) {
        if (data.canonicalUrl !== false) {
            this.canonical.setCanonicalUrl(data.canonicalUrl);
        }
        if (data.title) {
            const suffix = (data.appendTitleSuffix !== false && this.config.titleSuffix) || '';
            this.titleService.setTitle(`${data.title}${suffix}`);
        }
        if (data.description) {
            this.metaTagService.updateTag({
                name: 'description',
                content: data.description,
            });
        }
        if (data.tags) {
            this.metaTagService.addTags(data.tags);
        }
        if (data.robots) {
            this.metaTagService.addTag({
                name: 'robots',
                content: this.generateRobotsTagValue(data.robots),
            });
        }
        if (data.opengraph !== false) {
            const opengraph = Object.assign(Object.assign({}, (this.config.defaultOpenGraph || {})), (data.opengraph || {}));
            if (!opengraph.title && data.title) {
                opengraph.title = data.title;
            }
            if (!opengraph.description && data.description) {
                opengraph.description = data.description;
            }
            //todo: automatically rewrite url with BASE_URL token (images etc)?
            this.metaTagService.addTags(ogRecordToArray(opengraph));
        }
        if (data.structuredData) {
            this.jsonLd.insertSchema(Object.assign({ '@context': 'http://schema.org' }, data.structuredData));
        }
    }
    generateRobotsTagValue(data) {
        return [
            //none same as nofollow + noindex
            data.index === false && data.follow === false ? 'none' : false,
            data.index === false && data.follow !== false ? 'noindex' : false,
            data.follow === false && data.index !== false ? 'nofollow' : false,
            data.follow === true ? 'follow' : false,
            data.imageIndex === false ? 'noimageindex' : false,
            data.snippet === false ? 'nosnippet' : false,
            data.archive === false ? 'noarchive' : false,
        ]
            .filter((v) => !!v)
            .join(', ');
    }
}
SeoService.ɵfac = function SeoService_Factory(t) { return new (t || SeoService)(ɵngcc0.ɵɵinject(CanonicalService), ɵngcc0.ɵɵinject(ɵngcc2.Title), ɵngcc0.ɵɵinject(ɵngcc2.Meta), ɵngcc0.ɵɵinject(JsonLdService), ɵngcc0.ɵɵinject(SEO_CONFIG)); };
SeoService.ɵprov = i0.ɵɵdefineInjectable({ factory: function SeoService_Factory() { return new SeoService(i0.ɵɵinject(CanonicalService), i0.ɵɵinject(i2$1.Title), i0.ɵɵinject(i2$1.Meta), i0.ɵɵinject(JsonLdService), i0.ɵɵinject(SEO_CONFIG)); }, token: SeoService, providedIn: "root" });
SeoService.ctorParameters = () => [
    { type: CanonicalService },
    { type: Title },
    { type: Meta },
    { type: JsonLdService },
    { type: undefined, decorators: [{ type: Inject, args: [SEO_CONFIG,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SeoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: CanonicalService }, { type: ɵngcc2.Title }, { type: ɵngcc2.Meta }, { type: JsonLdService }, { type: undefined, decorators: [{
                type: Inject,
                args: [SEO_CONFIG]
            }] }]; }, null); })();

//types

class SharedUtilFoundationModule {
}
SharedUtilFoundationModule.ɵfac = function SharedUtilFoundationModule_Factory(t) { return new (t || SharedUtilFoundationModule)(); };
SharedUtilFoundationModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SharedUtilFoundationModule });
SharedUtilFoundationModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SharedUtilFoundationModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SharedUtilFoundationModule, { imports: function () { return [CommonModule]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { BASE_URL, CanonicalService, GOOGLE_TAG_MANAGER, GTM_CONFIG, GtmButtonDirective, GtmConfigService, GtmLinkDirective, GtmPropStyle, GtmService, QMSanitiseDirective, QuantumMetricsService, QuantumMetricsTransition, RecaptchaWithCleanupService, SEO_CONFIG, SeoService, SharedUtilFoundationModule, SharedUtilGtmModule, SharedUtilQuantumMetricsModule, WINDOW, buildUrl, clone, combineLatestObj, distinctUntilChangedDeep, distinctUntilKeysChanged, equal, filterNullUndefined, forkJoinObj, formatHttpPayload, formatUrl, generateId, getActivatedRoute, getRouteData, getRouteParams, getRouteUrl, httpParamsFromObject, mapToLatestFrom, memoryStorageSync, retrieveErrorMessage, retrieveErrorStatusCode, selectDispatchIfUndefined, sessionStorageEnabled, sessionStorageSync };

